<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between" [ngClass]="(memberCard$ | async)?.ProductCode | background">
    <a class="nav-logo" [routerLink]="['/']" routerLinkActive="router-link-active">
      <img src="assets/images/nav-logo.png" alt="" />
    </a>
    <img class="mobile-nav-menu-logo" src="assets/images/birdland-rewards-logo.png" draggable="false" />
    <!--Notifications-->
    <div class="right-mobile-nav-menu">
      <div class="ms-auto">
        <fgb-notification-button></fgb-notification-button>
      </div>
      <button class="nav-item fw-bold navbar-toggler m-0 p-0" aria-label="Menu" (click)="isCollapsed = !isCollapsed">
        <i class="material-symbols-outlined text-white">menu</i>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown">
    <div class="d-flex flex-column mobile-nav-menu-content">
      <div class="header-menu-dropdown d-flex flex-row justify-content-between">
        <a class="nav-item fw-bold brand p-0" [routerLink]="['/']" routerLinkActive="router-link-active">
          <img class="mobile-menu-logo" src="assets/images/nav-logo.png" draggable="false" />
        </a>
        <!-- Close Button -->
        <button class="close-button text-right border-0 p-0" aria-label="Close Modal" (click)="isCollapsed = !isCollapsed">
          <i class="material-icons">close</i>
        </button>
      </div>

      <ng-container *ngIf="memberCard$ | async as card">
        <div class="mobile-nav-menu-details d-flex flex-column">
          <div class="upper-barcode-container d-flex flex-row align-items-center justify-content-between">
            <!--Name and ID-->
            <div class="d-flex flex-column gap-1">
              <h4
                class="member-name font-size-18 fw-bold text-uppercase m-0 text-white"
                *ngIf="memberDetails$ | async as memberDetails"
              >
                {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
              </h4>
              <div class="d-flex flex-row align-items-center font-size-12 text-white">
                <span>{{ card.ProductCode }}</span>
                <span class="px-1">-</span>
                <span>{{ card.ExternalRefNumber }}</span>
              </div>
            </div>
          </div>

          <!--Balances-->
          <div class="balance bg-glass-dark d-flex flex-row justify-content-between align-items-center">
            <span class="font-size-14 text-white text-capitalize">{{ 'barcode.your.points' | translate }}</span>

            <div class="points-container d-flex flex-row align-items-center justify-content-center">
              <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
              <span class="fw-bold text-white font-size-20 font-heading">{{ pointsBalance$ | async | number: '1.0-0' }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Nav Buttons -->
      <div class="mobile-nav-button-container">
        <a
          class="nav-item fw-bold large-item"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <h4 class="nav-text fw-bold">{{ 'nav.account' | translate }}</h4>

          <span class="material-icons icon">navigate_next</span>
        </a>

        <a class="nav-item" [routerLink]="['/rewards']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <h4 class="nav-text fw-bold">{{ 'nav.rewards' | translate }}</h4>

          <span class="material-icons icon">navigate_next</span>
        </a>

        <a
          class="nav-item"
          [routerLink]="['/rewards/wallet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <h4 class="nav-text fw-bold">{{ 'nav.wallet' | translate }}</h4>

          <span class="material-icons icon">navigate_next</span>
        </a>

        <ng-container *notInProductCode="[productCode.Partners]">
          <a
            class="nav-item"
            [routerLink]="['/badges']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <h4 class="nav-text fw-bold">{{ 'nav.challenges' | translate }}</h4>

            <span class="material-icons icon">navigate_next</span>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/earn']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            *notInProductCode="productCode.Partners"
          >
            <h4 class="nav-text fw-bold">{{ 'nav.earn' | translate }}</h4>

            <span class="material-icons icon">navigate_next</span>
          </a>

          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.partners'">
            <ng-container *inProductCode="productCode.ShouldSeePartners">
              <a
                class="nav-item"
                [routerLink]="['/partners']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <h4 class="nav-text fw-bold">{{ 'account.nav.partners' | translate }}</h4>

                <span class="material-icons icon">navigate_next</span>
              </a>

              <a
                class="nav-item"
                [routerLink]="['/pointsmanagement']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <h4 class="nav-text fw-bold">{{ 'account.nav.points.transfer' | translate }}</h4>

                <span class="material-icons icon">navigate_next</span>
              </a>
            </ng-container>
          </ng-container>
        </ng-container>

        <a class="nav-item" [href]="'privacy.policy.link' | translate">
          <h4 class="nav-text fw-bold">{{ 'nav.privacy' | translate }}</h4>

          <span class="material-icons icon">navigate_next</span>
        </a>

        <a class="nav-item" [routerLink]="['/terms']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <h4 class="nav-text fw-bold">{{ 'nav.terms' | translate }}</h4>

          <span class="material-icons icon">navigate_next</span>
        </a>
        <a class="nav-item" [routerLink]="['/faq']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <h4 class="nav-text fw-bold">{{ 'nav.faq' | translate }}</h4>

          <span class="material-icons icon">navigate_next</span>
        </a>

        <a class="nav-item" [routerLink]="['/contact']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <h4 class="nav-text fw-bold">{{ 'nav.contact.us' | translate }}</h4>

          <span class="material-icons icon">navigate_next</span>
        </a>

        <a class="nav-item" [href]="'terms.of.use.link' | translate">
          <h4 class="nav-text fw-bold">{{ 'nav.terms.of.use' | translate }}</h4>

          <span class="material-icons icon">navigate_next</span>
        </a>

        <a class="nav-item" (click)="logout()">
          <h4 class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</h4>
        </a>

        <p class="font-size-14 text-white bottom-website-content">{{ 'mobile.nav.copy.right' | translate }}</p>
      </div>
    </div>
  </div>
</div>
